import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getManagerReplies: analyticsTypes.GetManagerReplies = (params) => {
  return axios.get(`/analytics/manager-replies`, { params });
};

type QueryFnType = typeof getManagerReplies;

type UseGetManagers = {
  config?: QueryConfig<QueryFnType>;
  filter: analyticsTypes.GetManagerRepliesParams;
};

export const useGetManagersReplies = ({ config, filter }: UseGetManagers) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['analytics-managers'],
    queryFn: () => getManagerReplies(filter),
    initialData: () => ({ data: [], series: [] }),
    enabled: false,
  });
};
